/* eslint-disable no-param-reassign */
import formatter from '../utils/format-time';

function before(date) {
  return {
    disabledDate(time) {
      if (!date) {
        return false;
      }
      date = formatter.formatDate(date);
      time = formatter.formatDate(time);
      return time > date;
    },
  };
}
function after(date) {
  return {
    disabledDate(time) {
      if (!date) {
        return false;
      }
      date = formatter.formatDate(date);
      time = formatter.formatDate(time);
      return time < date;
    },
  };
}

const PickerOptionsMaker = {
  install(Vue) {
    Vue.prototype.$_yh_before = before;
    Vue.prototype.$_yh_after = after;
  },
};

export default PickerOptionsMaker;
